// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-3f15face]{padding-bottom:30px}.header[data-v-3f15face]{display:flex;justify-content:space-between;align-items:center;margin-top:24px}.header__title[data-v-3f15face]{font-weight:700;font-size:17px;line-height:22px;color:#2c353b;margin:0}.header__button[data-v-3f15face]{font-weight:510;font-size:14px;line-height:18px;color:#2c353b;margin:0}.groups[data-v-3f15face]{margin-bottom:32px}.groups__notification[data-v-3f15face]{text-align:center;color:#2c353b}", ""]);
// Exports
module.exports = exports;
